import { render, staticRenderFns } from "./RegisterBranch.vue?vue&type=template&id=66c31710&"
import script from "./RegisterBranch.vue?vue&type=script&lang=js&"
export * from "./RegisterBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports